module.exports = __webpack_public_path__ + "static/luth-logo-192-dc8df773258fdf674f7058ccba6cbc55.png";